import React, { useContext, useEffect } from 'react';
import { StateContext } from 'context';
import './nosotros.css';
import { withRouter } from "react-router-dom";
import { Themes } from 'styles';
// import { Plantel } from 'assets/img';
const Nosotros = (props) => {
    const state = useContext(StateContext);
    const indexTema = state && state.appReducer && state.appReducer.indexTema ? state.appReducer.indexTema : 0;
    useEffect(() => {

    }, []);

    return (
        <>
            <div id="nosotros" className="w3-block">
                <div className="w3-content">
                    <div className="w3-block w3-center titulo">
                        <h1 style={{ color: Themes[indexTema].D4 }}>Nosotros</h1>
                    </div>
                    <div className="w3-row" style={{ margin:'0 40px' }}>
                        {/* <div className="w3-col l5 w3-padding bs-bbox"> */}
                            <p><span className="font-lato-bold">Servitravel</span> es una Empresa Paraguaya de Viajes y Turismo fundada en junio de 1996 con el objetivo de brindar toda la asistencia y opciones necesarias al viajero para el éxito de sus viajes vacacionales, de negocios o placer.</p>
                            <p>Habilitada por la Secretaría General de Turismo (SENATUR) en abril de 1997 y designada en 1998 como agencia autorizada por la Internacional Air Transpot Association (IATA) amplia aún más la eficiencia en la presentación de sus servicios. Asociada a la ASATUR (Asociación Paraguaya de Agencias de Viajes y Turismo), organismo que avala nuestra trayectoria.</p>
                        {/* </div> */}
                        {/* <div className="w3-col l7 w3-padding bs-bbox">
                            <img className="w3-card" src={Plantel} alt="plantel"/>
                        </div> */}
                    </div>
                </div>
            </div>
        </>
    );
}
export default withRouter(Nosotros);